import { LinkUtilsServiceDefinition } from '@wix/link-utils'
import { WixClientDefinition } from '@wix/viewer-service-wix-client/definition'
import { BusinessLoggerDefinition } from '@wix/viewer-service-business-logger/definition'
import { UrlDefinition } from '@wix/viewer-service-url/definition'
import _ from 'lodash'

export const noopServiceImplementations = {
	[LinkUtilsServiceDefinition as string]: {
		getImpliedLinks: (html: string) => {
			return html.replace(/(https?:\/\/[^\s<]+)/g, (url) => `<a href="${url}">${url}</a>`)
		},
	},
	[WixClientDefinition as string]: {
		getWixClient: () => 'string wix client',
	},
	[BusinessLoggerDefinition as string]: {
		reportBi: () => {},
	},
	[UrlDefinition as string]: {
		getCurrentUrl: () => '',
		getCurrentUrlWithQueryParams: () => '',
		getRelativeUrl: () => '',
		getExternalBaseUrl: () => '',
		pushUrlState: () => {},
		getFullUrlWithoutQueryParams: () => '',
	},
}
